<p *ngIf="!!content" class="bl-margin--0 bl-overflow-wrap--break-word" #pContentTagID [ngClass]="formatter" [innerHtml]="content | safe: 'html'" ></p>
